import { InstantSearch, Configure, useStats, useInstantSearch } from "react-instantsearch";
import { NoResultFound } from "./noResultFound";
import { ProductSkeletonLoader } from "./productSkeletonLoader";
import { Fragment } from "react";

const ShowWhenHasResults = ({ children, query }) => {
  const { nbHits } = useStats();
  const { status, results } = useInstantSearch();
  const obj = useInstantSearch();

  // While a NEW query is in flight the results in hand are still the previous query's, so nbHits
  // is > 0 and the old grid kept rendering (dimmed) until the new results landed - the loader
  // never appeared. Show it for that gap instead.
  //
  // Paging does not trigger this: showMore() moves `page`, it does not change `results.query`.
  // `query === undefined` (the category page) leaves the old behaviour untouched.
  const isPendingNewQuery = query !== undefined && results && String(results.query ?? "") !== String(query ?? "");
  if (isPendingNewQuery) return <ProductSkeletonLoader />;

  const isNoResults = status === "idle" && results && results.nbHits === 0;
  if (isNoResults) {
    return <NoResultFound />;
  } else if (nbHits === 0) {
    return <ProductSkeletonLoader />;
  } else return <Fragment>{children}</Fragment>;
};
export default ShowWhenHasResults;
